const actions = {
  GET_QUESTION_ALL_REQUEST: "GET_QUESTION_ALL_REQUEST",
  GET_QUESTION_ALL_SUCCESS: "GET_QUESTION_ALL_SUCCESS",
  GET_QUESTION_ALL_ERROR: "GET_QUESTION_ALL_ERROR",

  SEND_ANSWER_REQUEST: "SEND_ANSWER_REQUEST",
  SEND_ANSWER_SUCCESS: "SEND_ANSWER_SUCCESS",
  SEND_ANSWER_ERROR: "SEND_ANSWER_ERROR",

  GET_RESULT_REQUEST: "GET_RESULT_REQUEST",
  GET_RESULT_SUCCESS: "GET_RESULT_SUCCESS",
  GET_RESULT_ERROR: "GET_RESULT_ERROR",

  GET_EXAM_REQUEST: "GET_EXAM_REQUEST",
  GET_EXAM_SUCCESS: "GET_EXAM_SUCCESS",
  GET_EXAM_ERROR: "GET_EXAM_ERROR",

  GET_ANSWER_SHEET:"GET_ANSWER_SHEET",
  GET_ANSWER_SHEET_SUCESS:'GET_ANSWER_SHEET_SUCESS',
  GET_ANSWER_SHEET_ERROR:'GET_ANSWER_SHEET_ERROR',



  GET_SINGLE_ANSWER:"GET_SINGLE_ANSWER",
  GET_SINGLE_ANSWER_SUCESS:'GET_SINGLE_ANSWER_SUCESS',
  GET_SINGLE_ANSWER_ERROR:'GET_SINGLE_ANSWER_ERROR',

  RESET_ACTION_TYPE: "RESET_ACTION_TYPE",

  RESET_ACTION_TYPE1: "RESET_ACTION_TYPE1",


  getexamdetails: (url) => ({
    type: actions.GET_EXAM_REQUEST,
    payload: { url },
  }),

 getanswersheet: (url) => ({
    type: actions.GET_ANSWER_SHEET,
    payload: { url },
  }),

  getallQuestions: (url) => ({
    type: actions.GET_QUESTION_ALL_REQUEST,
    payload: { url },
  }),
  sendAnswer: (url, body) => ({
    type: actions.SEND_ANSWER_REQUEST,
    payload: { url, body },
  }),

  resultget: (url) => ({
    type: actions.GET_RESULT_REQUEST,
    payload: { url },
  }),

  singleResult: (url) => ({
    type: actions.GET_SINGLE_ANSWER,
    payload: { url },
  }),


  resetActionType: () => ({
    type: actions.RESET_ACTION_TYPE,
  }),

  resetActionType1: () => ({
    type: actions.RESET_ACTION_TYPE1,
  }),
};

export default actions;
